import { render, staticRenderFns } from "./Accordion3.vue?vue&type=template&id=37fbd78c&scoped=true&"
import script from "./Accordion3.vue?vue&type=script&lang=js&"
export * from "./Accordion3.vue?vue&type=script&lang=js&"
import style0 from "./Accordion3.vue?vue&type=style&index=0&id=37fbd78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbd78c",
  null
  
)

export default component.exports